export const validateCustomerForm = ({firstName, lastName, email, phone}: any )=> {
 const errors = {
    firstName: '',
    lastName: '',
    phone: '',
   
  
  };
  if (!firstName) {
    errors.firstName = 'First Name is required';
   
  }
  if (!lastName) {
    errors.lastName = 'Last Name is required';
    
  }
  if (!phone) {
    errors.phone = 'Phone is required';
  
  }
 
 // Check if any error messages are present
 const hasErrors = Object.values(errors).some(error => error !== '');




return { hasErrors, errors };
};
